import { useNavigate,Link } from "react-router-dom";
import { useState} from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import { Helmet } from 'react-helmet';
import { socket } from "./Socket";

const Login = () =>{
  const backendUrl = process.env.REACT_APP_BACKEND_URL; 
  const navigate=useNavigate();
 const [phone,setPhone]=useState();
 const[password,setPassword]=useState();

 const [otp, setOtp] = useState("");
  
   
 const [showPassword,setShowPassword]=useState(false);

  
 const sendOTP = async (e) => {
  e.preventDefault();
  
  try {
    const response = await axios.post(`${backendUrl}api/loginOTP`, { phone });

    if (response.status === 201) {
      toast.success("OTP sent successfully!", { position: "top-right" });
    }else{
      toast.error("Network error, please check your connection!", { position: "top-right" });
    }

  } catch (error) {
    if (error.response) {
      const { status, data } = error.response;

      if (status === 404) {
        toast.error(data.message ,{ position: "top-right" });
      } else if (status === 500) {
        toast.error(data.message || "Internal Server Error. Please try again!", { position: "top-right" });
      } else {
        toast.error("An unexpected error occurred!", { position: "top-right" });
      }
    } else {
      toast.error("Network error, please check your connection!", { position: "top-right" });
    }
  }
};



const isLogin = async (e) => {
  try {
    const response = await axios.post(`${backendUrl}api/login`, {
      phone,
    
    });

    if (response.status === 200) {   //  Proper check
      sessionStorage.setItem("phone", phone);
      localStorage.setItem("phone", phone);
      Cookies.set("mobile", phone, { expires: 7 });

      toast.success("Successfully logged in!", { position: "top-right" });
      navigate("/chatboard");
    }
  } catch (error) {
    toast.error("Invalid credentials !", { position: "top-right" });
  }
};


  const togglePassword = () => {
    setShowPassword(prev => !prev);
  };


const verifyOTP = async () => {
 

  try {
    let inputs = document.getElementsByTagName("input");

    for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].value === "") {
            inputs[i].classList.add("border");
        }
    }
    const response = await axios.post(`${backendUrl}api/verifyloginOTP`, {
      phone,
      otp: otp,
    });
   
    if (response.status === 200) {
      toast.success("OTP Verified!", { position: "top-right" });
     isLogin();
    } else if(response.status===400) {
      toast.error("Invalid OTP!", { position: "top-right" });
    }
  } catch (error) {
    toast.error("Please fill the form !", { position: "top-right" });
  }
};

 

const handleChange = (e)=>{
  setPhone(e.target.value);

}
const getBorderColor = () => {
 
   if (!phone) return "1px solid silver";
    if (phone.length < 10) return "2px solid rgb(255, 221, 0)";
    if (phone.length === 10) return "2px solid green";
    if (phone.length > 10) return "2px solid #ff3838";
    return "";
  };


const getOtpColor = () => {

   if (!otp) return "1px solid silver";
    if (otp.length < 6) return "rgb(255, 221, 0)";
    if (otp.length === 6) return "green";
    if (otp.length > 6) return "red";
    return "";
  };




  return <div>
   
  <div className="logo">
      <div className="img">
      <img src="./Images/app.png" alt="Not found" />
      </div>
  

  </div>

<div className="container clogin">
  <h2>Login Here</h2>
  <ToastContainer />
  <form onSubmit={sendOTP}>
    
      <div className="input-field mobile">
          
          <input type="number" value={phone} onChange={handleChange} placeholder="Mobile No (10 digits)"required  
          style={{
        border: `${getBorderColor()}`,
        borderRadius: "5px",
         color:"black",
        outline: "none"
      }}
          />
      </div>

      <div className="otp">
            <input type="number" onChange={(e)=>setOtp(e.target.value)}   autoComplete="one-time-code" id="otp" placeholder="# Code" 
            style={{
       
         color: `${getOtpColor()}`,
        borderRadius: "5px",
        
        outline: "none"
      }}
            
            /><button type="submit"  id="sc">Send Code</button>
          </div>
    
      <button type="button" onClick={verifyOTP} className="login" >Login</button>
    
      <div className="line"></div>
      <button  className="signup" onClick={()=>{navigate("/signup")}}>Signup</button>
  </form>

</div>



</div>
}
export default Login;